import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { CommonService } from '../shared/services/common.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private commonServ: CommonService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError((err: any) => {
            if (err.status === 401) {
                this.commonServ.showError({message:"Session Expired"});
                this.commonServ.redirectToLanding();
            }
            else if (err.status == 404) {
                err.error  = {
                    message: 'Something went wrong, please try again later'
                };
            }
            else if (err?.status?.toString()[0] == '5') {
                err.error  = {
                    message: 'Something went wrong, please try again later'
                };
            }
            this.commonServ.hideLoader();
            const error = err;
            return throwError(() => error);
        }))
    }
}
